import { render, staticRenderFns } from "./r-exchange-dialog.vue?vue&type=template&id=07201646&scoped=true"
import script from "./r-exchange-dialog.vue?vue&type=script&lang=js"
export * from "./r-exchange-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-exchange-dialog.vue?vue&type=style&index=0&id=07201646&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07201646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07201646')) {
      api.createRecord('07201646', component.options)
    } else {
      api.reload('07201646', component.options)
    }
    module.hot.accept("./r-exchange-dialog.vue?vue&type=template&id=07201646&scoped=true", function () {
      api.rerender('07201646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/exchange/r-exchange-dialog.vue"
export default component.exports